
<form ngForm (ngSubmit)="submit(paymentForm.form)" #paymentForm="ngForm">
  <div class="row mt-sm mx-none">
    <div class="col-12">
      <div class="col-12">
        <div class="">
          <h3>{{'signup.payment.paymentMethod' | translate}} *</h3>
          <ng-container *ngIf="methods!==null">
            <div class="d-flex flex-column" #paymentMethods='ngModelGroup' ngModelGroup="paymentMethods" >
              <div class="d-flex align-items-center gap-2 mt-2">
                <p-radioButton required name="method1" [value]="methods[0]" [(ngModel)]="model.paymentMethodType" inputId="method1" data-testid="method1-radio"></p-radioButton>
                <label for="method1">{{ 'signup.payment.paymentOrder' | translate }}</label>
              </div>
              <div class="d-flex align-items-center gap-2 mt-2">
                <p-radioButton [(ngModel)]="model.paymentMethodType" [value]="methods[1]" name="method2" [customRequiredTrue]='"paymentMethods"' inputId="method2" data-testid="method2-radio"></p-radioButton>
                <label for="method2">{{ 'signup.payment.card' | translate }}</label>
              </div>
            </div>
            <div [style]="{color: 'red'}" *ngIf="!paymentMethods.valid && paymentMethods.touched" >{{'signup.payment.error' | translate}}</div>
          </ng-container>

        </div>
        <div *ngIf="showTermsAndConditions" class="mt-4">
          <h3>{{'signup.payment.terms' | translate}} *</h3>
          <div class="d-flex align-items-center gap-2 mt-2">
            <p-checkbox #terms='ngModel' [(ngModel)]="termsAndConditions" [customRequiredTrue]='"terms"' [binary]="true" required name="terms" inputId="terms" data-testid="terms-checkbox"></p-checkbox>
            <label for="terms">{{ 'signup.payment.termsAccept' | translate }}</label>
          </div>
          <div [style]="{color: 'red'}" *ngIf="!terms.valid && terms.touched" >{{'signup.payment.error' | translate}}</div>
        </div>
      </div>
    </div>
    <p *ngIf="showTermsAndConditions" class="mt-2"> {{'signup.payment.go' | translate}} <a [routerLink]="['/info/gdpr-terms-and-conditions']" target='_blank' class="mb-xl" data-testid="terms-and-conditions-link">
      {{'signup.terms-and-conditions' | translate}} </a>
    </p>
    <div class="d-flex justify-end mt-5 mb-3 me-4">
      <button [style]="{width:'130px'}" [label]="'signup.save' | translate" type="submit" pButton class="p-button-outlined save-button" data-testid="submit-btn"></button>
    </div>
  </div>
</form>


